import React from 'react';
import { X, CheckCircle, AlertCircle, AlertTriangle, Info } from 'lucide-react';

const icons = {
  success: <CheckCircle className="w-5 h-5 text-green-400" />,
  error: <AlertCircle className="w-5 h-5 text-red-400" />,
  warning: <AlertTriangle className="w-5 h-5 text-yellow-400" />,
  info: <Info className="w-5 h-5 text-blue-400" />,
};

const styles = {
  success: 'border-l-4 border-green-500 bg-gray-800',
  error: 'border-l-4 border-red-500 bg-gray-800',
  warning: 'border-l-4 border-yellow-500 bg-gray-800',
  info: 'border-l-4 border-blue-500 bg-gray-800',
};

const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles[toast.type]} text-white px-4 py-3 rounded-lg shadow-lg 
                      transform transition-all duration-300 animate-slide-in
                      flex items-center gap-3 min-w-[300px]`}
        >
          {icons[toast.type]}
          <span className="flex-1 text-sm">{toast.message}</span>
          <button
            onClick={() => removeToast(toast.id)}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
